export enum EstatusDesaparicionEnum {
    LOCALIZADA_CON_VIDA = "2",
    LOCALIZADA_SIN_VIDA = "3",
    DESAPARECIDO = "4",
    NO_LOCALIZADO = "5"
}